import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-p-2 content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LanguagesList = _resolveComponent("LanguagesList")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TranslationListView = _resolveComponent("TranslationListView")!
  const _component_TranslationImportView = _resolveComponent("TranslationImportView")!
  const _component_TranslationExportView = _resolveComponent("TranslationExportView")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_LanguageForm = _resolveComponent("LanguageForm")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_EntryDialog = _resolveComponent("EntryDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_TabView, {
        activeIndex: _ctx.activeTabOption,
        "onUpdate:activeIndex": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTabOption) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "mdi mdi-format-list-checks" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Squeeze.System.Selection')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_LanguagesList, {
                loading: _ctx.loading,
                allLanguages: _ctx.allLanguages,
                onOnChangeActiveStatus: _ctx.onChangeActiveStatus,
                onOnEntrySelect: _ctx.onEntrySelect
              }, null, 8, ["loading", "allLanguages", "onOnChangeActiveStatus", "onOnEntrySelect"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _cache[3] || (_cache[3] = _createElementVNode("i", { class: "mdi mdi-translate" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Squeeze.System.Translations')), 1)
            ]),
            default: _withCtx(() => [
              (_ctx.translationTabLoaded)
                ? (_openBlock(), _createBlock(_component_TranslationListView, { key: _ctx.translationListKey }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("i", { class: "mdi mdi-file-import-outline" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Squeeze.General.Import')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_TranslationImportView)
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _cache[5] || (_cache[5] = _createElementVNode("i", { class: "mdi mdi-file-export-outline" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Squeeze.General.Export')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_TranslationExportView)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["activeIndex"])
    ]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showEditDialog,
      onOnClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showEditDialog = false, _ctx.isValidationInvalid = true, _ctx.showValidationMessage = false)),
      onOnConfirm: _ctx.saveLanguage,
      loading: _ctx.loadingDialog,
      headerText: _ctx.headerText,
      showKeepDialogOpen: false
    }, {
      content: _withCtx(() => [
        _createVNode(_component_BlockUI, { blocked: _ctx.loadingDialog }, {
          default: _withCtx(() => [
            _createVNode(_component_LanguageForm, {
              language: _ctx.language,
              showErrorMessage: _ctx.showValidationMessage,
              onUpdate: _ctx.onUpdate
            }, null, 8, ["language", "showErrorMessage", "onUpdate"])
          ]),
          _: 1
        }, 8, ["blocked"])
      ]),
      _: 1
    }, 8, ["show", "onOnConfirm", "loading", "headerText"])
  ], 64))
}